import { Trans, useLingui } from "@lingui/react/macro";

import { useQuitAccount } from "~/hook/overlay/useQuitAccount.ts";
import { ModalNavigation } from "~/ui/base/Navigation.tsx";
import { createStackedPage } from "~/ui/base/StackedPage.tsx";

const cx = {
  formItem: "flex flex-col gap-2 h-32 duration-300 mt-5",
  helper: "text-sm text-zinc-600 dark:text-zinc-400",
  input:
    "border border-zinc-200 dark:border-zinc-800 rounded-sm text-zinc-800 dark:text-zinc-100 bg-transparent p-2",
  label: "text-lg",
};

export const QuitStack = createStackedPage(({ close, titleId }) => {
  const { t } = useLingui();
  const {
    disabled,
    handleSubmit,
    hasError,
    isMutating,
    setPassword,
    translatedPasswordError,
  } = useQuitAccount();

  return (
    <div>
      <ModalNavigation
        left={{
          disabled: isMutating,
          label: t`취소`,
          onClick: close,
        }}
        right={{
          disabled,
          label: t`계속`,
          onClick: handleSubmit,
        }}
        title={t`요기콕콕! 계정 삭제`}
        titleId={titleId}
      />
      <div className="h-[calc(4rem+var(--safe-top))]"></div>
      <div className="p-5">
        <p className="py-5 text-zinc-600 dark:text-zinc-400">
          <Trans>
            계정 삭제는 영구적입니다. 요기콕콕! 게정을 삭제하시면 회원님의 모든
            활동이 영구 삭제됩니다.
          </Trans>
        </p>
        <div className={cx.formItem}>
          <label className={cx.label} htmlFor="password">
            <Trans>비밀번호</Trans>
          </label>
          <input
            className={cx.input}
            disabled={isMutating}
            id="password"
            name="password"
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            type="password"
          />
          {hasError && <p className={cx.helper}>{translatedPasswordError}</p>}
        </div>
      </div>
    </div>
  );
});
